import { Stripe, loadStripe } from "@stripe/stripe-js"
import { paymentRPO } from "payment/repository"
import { paymentState } from "payment/state"

export const getStripe = async (): Promise<Stripe> => {
  if (paymentState.stripe) {
    return paymentState.stripe
  }
  const publicKey = await paymentRPO.getStripePublicAPIKey()
  paymentState.stripe = (await loadStripe(publicKey)) as Stripe
  if (!paymentState.stripe) {
    throw Error("Unable to get stripe")
  }
  return paymentState.stripe
}
